var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/pagination-macro.j2"] = require( "macros/pagination-macro.j2" );
dependencies["product-reviews-header.j2"] = require( "product-reviews-header.j2" );
dependencies["product-reviews-summary.j2"] = require( "product-reviews-summary.j2" );
dependencies["product-reviews.j2"] = require( "product-reviews.j2" );
dependencies["product-reviews-disclaimer.j2"] = require( "product-reviews-disclaimer.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-container.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/pagination-macro.j2", false, "product/templates/product-reviews-container.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("buildPagination")) {
var t_4 = t_1.buildPagination;
} else {
cb(new Error("cannot import 'buildPagination'")); return;
}
context.setVariable("buildPagination", t_4);
output += "\n";
var t_5;
t_5 = (lineno = 1, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.isVintage",false]));
frame.set("isVintage", t_5, true);
if(frame.topLevel) {
context.setVariable("isVintage", t_5);
}
if(frame.topLevel) {
context.addExport("isVintage", t_5);
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"Includes")) {
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"Includes");
frame.set("includes", t_6, true);
if(frame.topLevel) {
context.setVariable("includes", t_6);
}
if(frame.topLevel) {
context.addExport("includes", t_6);
}
;
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"Includes") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"Includes")),"Products") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"Includes")),"Products")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"styleNumber"))) {
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "includes")),"Products")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"styleNumber"));
frame.set("includedProduct", t_7, true);
if(frame.topLevel) {
context.setVariable("includedProduct", t_7);
}
if(frame.topLevel) {
context.addExport("includedProduct", t_7);
}
;
}
var t_8;
t_8 = (lineno = 10, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","write a review click",(lineno = 10, colno = 65, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.bvTemplateType",(lineno = 10, colno = 96, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["mto.bvTemplateType"]))]))]));
frame.set("writeReviewGA", t_8, true);
if(frame.topLevel) {
context.setVariable("writeReviewGA", t_8);
}
if(frame.topLevel) {
context.addExport("writeReviewGA", t_8);
}
if(!runtime.contextOrFrameLookup(context, frame, "isVintage")) {
output += "\n\n    <div class=\"s-product-reviews u-jump-link dom-product-reviews js-product-reviews\" id=\"reviews\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
env.getTemplate("product-reviews-header.j2", false, "product/templates/product-reviews-container.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n            </div>\n\n        </div>\n\n        <div name=\"reviews\" data-qa-reviews-summary>\n\n            ";
env.getTemplate("product-reviews-summary.j2", false, "product/templates/product-reviews-container.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n        </div>";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"TotalResults") > 0) {
output += "<div class=\"c-product-reviews__controls js-product-reviews-top\">\n\n                <div class=\"o-row\">\n\n                    <div class=\"o-column o-extra-small--12 u-extra-small--hide u-medium--show\">\n\n                        ";
output += runtime.suppressValue((lineno = 40, colno = 40, runtime.callWrap(t_4, "buildPagination", context, ["product",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"totalPages"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"reviewPage"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"nextPage"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"prevPage"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productSlug")])), env.opts.autoescape);
output += "\n\n                    </div>\n\n                </div>\n\n            </div>\n\n            ";
env.getTemplate("product-reviews.j2", false, "product/templates/product-reviews-container.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n            <div class=\"o-row s-product-reviews-end\">\n\n                <div class=\"o-column o-extra-small--12\">\n\n                    ";
output += runtime.suppressValue((lineno = 54, colno = 36, runtime.callWrap(t_4, "buildPagination", context, ["product",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"totalPages"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"reviewPage"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"nextPage"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"prevPage"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productSlug")])), env.opts.autoescape);
output += "\n\n                </div>\n\n            </div>\n\n            <div class=\"o-row o-row--reverse\">\n\n                <div class=\"o-column o-extra-small--12 o-large--4 c-product-reviews__a-outer\">\n\n                    <div class=\"o-column o-medium--6 o-large--12 o-extra-small--centered\">\n\n                        <a class=\"c-product-reviews__a js-product-write-review\" data-qa-write-review ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "writeReviewGA"), env.opts.autoescape);
output += ">";
output += runtime.suppressValue((lineno = 66, colno = 119, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-write-review"])), env.opts.autoescape);
output += "</a>\n\n                    </div>\n\n                </div>\n\n                <div class=\"o-column o-extra-small--12\">\n\n                    ";
env.getTemplate("product-reviews-disclaimer.j2", false, "product/templates/product-reviews-container.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n                </div>\n\n            </div>";
})})})});
}
else {
output += "<div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 o-medium--4 o-medium--centered\">\n\n                    <a class=\"c-product-reviews__a js-product-write-review\" data-qa-write-review ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "writeReviewGA"), env.opts.autoescape);
output += ">";
output += runtime.suppressValue((lineno = 86, colno = 115, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-write-review"])), env.opts.autoescape);
output += "</a>\n\n                </div>\n\n            </div>";
;
}
output += "</div>\n\n";
})})})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-container.j2"] , dependencies)